import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['siret', 'companyName', 'error']

  get #siretInput() {
    return this.siretTarget.querySelector('input')
  }
  get #companyNameInput() {
    return this.companyNameTarget.querySelector('input')
  }

  connect() {
    this.lookup()
  }

  lookup() {
    const siret = this.#siretInput.value.trim()

    if (!/^\d{14}$/.test(siret)) {
      this.#resetCompanyName()
      return
    }

    this.#fetchCompanyName(siret)
  }

  async #fetchCompanyName(siret) {
    const response = await fetch(`/siret/${siret}`)

    if (!response.ok) {
      const { message } = await response.json()
      this.#showError(message)
      return
    }

    const { company_name } = await response.json()

    this.#hideError()
    this.#companyNameInput.value = company_name
    this.#companyNameInput.readOnly = true
  }

  #resetCompanyName() {
    this.#hideError()
    this.#companyNameInput.value = ''
    this.#companyNameInput.readOnly = false
  }

  #showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('hidden')
  }

  #hideError() {
    this.errorTarget.textContent = ''
    this.errorTarget.classList.add('hidden')
  }
}
